import { AlertCircle, Loader2, Lock, Mail } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../../api/client";
import { useAuthStore } from "../../store/authStore";

export default function AdminLogin() {
	const navigate = useNavigate();
	const login = useAuthStore((state) => state.login);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [settings, setSettings] = useState({
		app_name: "Proposta Admin",
		app_logo_url: "",
	});

	React.useEffect(() => {
		client
			.get("/settings/public")
			.then((res) => setSettings(res.data))
			.catch(() => {});
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			const response = await client.post("/auth/login", { email, password });
			const { token, user } = response.data;

			login(token, user);
			navigate("/admin");
		} catch (err) {
			setError(err.response?.data?.error || "Erro ao fazer login");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-[#0B0F19] to-[#1a1f2e] flex items-center justify-center p-4">
			<div className="w-full max-w-md">
				{/* Header */}
				<div className="text-center mb-8">
					<div className="flex justify-center mb-4">
						{settings.app_logo_url ? (
							<img
								src={settings.app_logo_url}
								alt={settings.app_name}
								className="h-16 object-contain"
							/>
						) : (
							<Lock className="w-12 h-12 text-cyan-500" />
						)}
					</div>
					<h1 className="text-3xl font-bold text-white mb-2">
						{settings.app_name}
					</h1>
					<p className="text-slate-400">
						Sistema de Gerenciamento de Propostas
					</p>
				</div>

				{/* Card */}
				<div className="bg-slate-900/50 backdrop-blur-xl border border-white/10 rounded-xl p-8 shadow-2xl">
					{error && (
						<div className="mb-6 p-4 bg-red-500/10 border border-red-500/20 rounded-lg flex gap-3">
							<AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
							<p className="text-red-200 text-sm">{error}</p>
						</div>
					)}

					<form onSubmit={handleSubmit} className="space-y-6">
						{/* Email Field */}
						<div>
							<label
								htmlFor="email"
								className="block text-sm font-medium text-slate-300 mb-2"
							>
								Email
							</label>
							<div className="relative">
								<Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
								<input
									id="email"
									type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									className="w-full bg-slate-800/50 border border-slate-700 rounded-lg pl-10 pr-4 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500/30 transition"
									placeholder="seu@email.com"
									required
								/>
							</div>
						</div>

						{/* Password Field */}
						<div>
							<label
								htmlFor="password"
								className="block text-sm font-medium text-slate-300 mb-2"
							>
								Senha
							</label>
							<div className="relative">
								<Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
								<input
									id="password"
									type="password"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									className="w-full bg-slate-800/50 border border-slate-700 rounded-lg pl-10 pr-4 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500/30 transition"
									placeholder="Sua senha"
									required
								/>
							</div>
						</div>

						{/* Submit Button */}
						<button
							type="submit"
							disabled={loading}
							className="w-full bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-700 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-2.5 rounded-lg transition flex items-center justify-center gap-2"
						>
							{loading ? (
								<>
									<Loader2 className="w-4 h-4 animate-spin" />
									Entrando...
								</>
							) : (
								"Entrar"
							)}
						</button>
					</form>

					{/* Footer */}
					<p className="text-center text-slate-500 text-sm mt-6">
						Versão 1.0.0
					</p>
				</div>

				{/* Footer */}
				<p className="text-center text-slate-600 text-xs mt-6">
					Proposta System
				</p>
			</div>
		</div>
	);
}
